export interface CursorPage<TItem> {
  items: TItem[];
  nextCursor?: string | null;
}

// The only pagination failure a cursor can't signal on its own: one that
// never advances. fetchPage owns every other failure (abort, non-OK
// response, network error) by throwing its own error, which propagates
// through unchanged.
export class RepeatedCursorError extends Error {}

export const walkCursorPages = async <TItem>(
  fetchPage: (cursor: string | undefined) => Promise<CursorPage<TItem>>,
  repeatedCursorMessage: string
): Promise<TItem[]> => {
  const allItems: TItem[] = [];
  const seenCursors = new Set<string>();
  let cursor: string | undefined;

  do {
    // Sequential: each cursor depends on the previous response.
    // eslint-disable-next-line no-await-in-loop
    const { items, nextCursor } = await fetchPage(cursor);
    allItems.push(...items);
    cursor = nextCursor ?? undefined;

    if (cursor) {
      if (seenCursors.has(cursor)) {
        throw new RepeatedCursorError(repeatedCursorMessage);
      }
      seenCursors.add(cursor);
    }
  } while (cursor);

  return allItems;
};
